import type { HelpFile } from '../../types/help'
import { RestrictionRuleViolationsTestIds } from '../../../testids/RestrictionRuleViolationsTestIds'

export const restrictionRuleViolationsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleViolationsTestIds.restrictionRuleViolations]:
      'Für diese Restriktionsregel erfasste Verstöße — Identitäten mit verbotenen Zugriffsprofilen im Widerspruch zur Regelbedingung.',
    [RestrictionRuleViolationsTestIds.emptyStateViolations]:
      'Keine Verstöße für diese Regel — Verstoßerkennung ausführen, um aktuelle Verstöße zu prüfen.',
    [RestrictionRuleViolationsTestIds.colDetectedAt]:
      'Zeitpunkt der ersten Erkennung des Verstoßes.',
    [RestrictionRuleViolationsTestIds.colIdentity]:
      'Identität, die gegen diese Restriktionsregel verstößt.',
    [RestrictionRuleViolationsTestIds.colResolvedAt]:
      'Zeitpunkt der Behebung — Zugriff entfernt oder Regel geändert; leer, wenn noch offen.',
    [RestrictionRuleViolationsTestIds.colViolatingProfile]:
      'Verbotenes Zugriffsprofil, das die verstoßende Identität hält.',
  },
}
